import { useQuery } from '@tanstack/react-query'
import { api } from './api'
import { DEFAULT_POLL_S } from './util'

export interface Meta {
  poll_interval_s: number
  control_tick_min: number
  control_arm: boolean
}

/**
 * Service cadence, cached for the session.
 *
 * Falls back to the shipped default rather than blocking a page on it: a
 * dashboard that cannot render its fleet because it does not yet know the poll
 * interval is worse than one whose freshness chips are briefly calibrated to
 * the default.
 */
export function useMeta(): Meta {
  const { data } = useQuery<Meta>({
    queryKey: ['meta'],
    queryFn: () => api<Meta>('/admin/meta'),
    staleTime: 60 * 60 * 1000,
  })
  return data ?? { poll_interval_s: DEFAULT_POLL_S, control_tick_min: 15,
                   control_arm: false }
}
